import React from 'react'
import { translate } from 'react-i18next'
import { LinkedInIcon } from '../SocialIcons'

const Slide = ({ slide, index, t }) => {
  const [name, surname] = t(`about.team.${index}.name`).split(' ')
  return (
    <div className="slide">
      <div className="slide-wrapper">
        <img alt="avatar" src={slide.img} />
        <div className="slide-title">
          <div>
            <h6>{name}</h6>
            <h6>{surname}</h6>
          </div>
          {slide.linkedinUrl && (
            <noindex>
              <a target="_blank" rel="noopener noreferrer nofollow" href={slide.linkedinUrl}>
                <LinkedInIcon />
              </a>
            </noindex>
          )}
        </div>
        <p className="subtitle-2">{t(`about.team.${index}.position`)}</p>
      </div>
    </div>
  )
}

export default translate('translations')(Slide)
